import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { HostedPage } from '@/classes/models'

export default class HostedPaymentPageService {
  /**
   * Get all hosted payment pages.
   *
   * @param {Context} context
   *
   * @return {Promise}
   */
  static getAll (context) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token
    }).then(response => {
      return response.data
    })

    request.then(response => {
      const data = (response.data || [])

      // Map to Hosted Page
      response.data = { hostedPages: data.map(hostedPage => new HostedPage(hostedPage)), version: data.lenght > 0 ? data[0].version : null }

      return response
    })

    return { request, cancelToken }
  }

  /**
   * Get a hosted payment page.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static get (context, reference) {
    let request = portalApi.get(`${this.endpoint(context)}/${reference}`).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to Hosted Page
      response.data = { hostedPage: new HostedPage(response.data), version: response.data.version }

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a hosted payment page
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (context, data) {
    return portalApi.post(this.endpoint(context), data)
  }

  /**
   * Update a hosted payment page.
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static update (context, reference, data) {
    return portalApi.put(`${this.endpoint(context)}/${reference}`, data)
  }

  /**
   * Delete a hosted payment page.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static delete (context, reference) {
    return portalApi.delete(`${this.endpoint(context)}/${reference}`)
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant', 'configuration'])}/hosted-pages`
  }
}
